import { createContext, useContext, useState, ReactNode } from 'react';

interface MinimapContextType {
  showMinimap: boolean;
  toggleMinimap: () => void;
  closeMinimap: () => void;
}

const MinimapContext = createContext<MinimapContextType | undefined>(undefined);

export function MinimapProvider({ children }: { children: ReactNode }) {
  const [showMinimap, setShowMinimap] = useState(false);

  const toggleMinimap = () => {
    setShowMinimap(prev => {
      const newValue = !prev;
      localStorage.setItem('minimapVisible', newValue.toString());
      return newValue;
    });
  };

  const closeMinimap = () => setShowMinimap(false);

  return (
    <MinimapContext.Provider value={{ showMinimap, toggleMinimap, closeMinimap }}>
      {children}
    </MinimapContext.Provider>
  );
}

export function useMinimap() {
  const context = useContext(MinimapContext);
  if (context === undefined) {
    throw new Error('useMinimap must be used within a MinimapProvider');
  }
  return context;
} 